/**
 * @fileoverview GET handler for the "/mongo_explorer/all_schemas" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { mongoExplorerAllSchemas } from "./constants";
import type { MongoExplorerAllSchemasResult } from "./types";
import { isMongoExplorerAllSchemasResult } from "./validators";

export const getMongoExplorerAllSchemas = reactQueryFetcherAdapter(
  mongoExplorerAllSchemas,
  (signal: AbortSignal): Promise<MongoExplorerAllSchemasResult> => {
    return fetch("/mongo_explorer/all_schemas", "GET", {}, { signal });
  },
  isMongoExplorerAllSchemasResult
);
